import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Form,
  FormGroup,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import PerfectScrollbar from "react-perfect-scrollbar";
import DynamicForm from "../general/DynamicForm";
import Creatable from "../../../components/common/CreatableSelect";
import { Colxx } from "../../../components/common/CustomBootstrap";
import { AddCommaNumber } from "../../../helpers/Utils";
import classnames from "classnames";

const ContentComponent = ({
  title,
  isOpen,
  toggle,
  onSubmit,
  onSubmitTransaction,
  data_dynamic_form,
  data_tags,
  values,
  data_stocks,
  setting,
  onChange,
  onChangePrice,
  onChangeDynamicForm,
  initialActiveTab = "1",
}) => {
  const [activeTab, setActiveTab] = useState(initialActiveTab);

  useEffect(() => {
    if (isOpen) {
      setActiveTab(initialActiveTab || "1");
    }
  }, [isOpen, initialActiveTab]);

  let items_select = [];
  items_select = data_stocks.map((item) => ({
    label: item.name,
    value: item.name,
  }));

  // For transaction tab - filter items from current provider
  let provider_items_select = [];
  if (values?.log?.length > 0) {
    provider_items_select = values.log
      .filter((_item) => _item.alias === "new")
      .map((o) => ({
        label: o.name,
        value: o.id,
      }));
  }

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      wrapClassName="modal-right"
      backdrop={true}
    >
      <Form
        onSubmit={(e) =>
          activeTab === "1" ? onSubmit(e) : onSubmitTransaction(e)
        }
      >
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody className="pad-125rem scrool modal-right-add">
          <Nav tabs className="separator-tabs mb-4">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggleTab("1")}
                style={{ cursor: "pointer" }}
              >
                <IntlMessages id="company-provider.info" />
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => toggleTab("2")}
                style={{ cursor: "pointer" }}
              >
                <i className="simple-icon-plus mr-1" />
                Thêm giao dịch
              </NavLink>
            </NavItem>
          </Nav>
          <PerfectScrollbar
            options={{
              suppressScrollX: true,
              wheelPropagation: false,
            }}
            id="modal-right__69vh"
          >
            <TabContent activeTab={activeTab}>
              {/* Tab 1: Provider Info */}
              <TabPane tabId="1">
                <FormGroup className="mt-3 has-float-label">
                  <Label for="name" className="text-muted">
                    <IntlMessages id="name" />
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    autoFocus={true}
                    type="text"
                    name="name"
                    id="name"
                    disabled={setting.viewonly && !setting.add}
                    value={values.name}
                    onChange={onChange}
                  />
                </FormGroup>
                <FormGroup className="has-float-label">
                  <Label for="phone" className="text-muted">
                    <IntlMessages id="phone" />
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="text"
                    name="phone"
                    id="phone"
                    disabled={setting.viewonly && !setting.add}
                    value={values.phone}
                    onChange={onChange}
                  />
                </FormGroup>
                <FormGroup className="has-float-label">
                  <Label for="email" className="text-muted">
                    <IntlMessages id="email" />
                  </Label>
                  <Input
                    type="email"
                    name="email"
                    id="email"
                    disabled={setting.viewonly && !setting.add}
                    value={values.email}
                    onChange={onChange}
                  />
                </FormGroup>
                <FormGroup className="has-float-label">
                  <Label for="address" className="text-muted">
                    <IntlMessages id="address" />
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="text"
                    name="address"
                    id="address"
                    disabled={setting.viewonly && !setting.add}
                    value={values.address}
                    onChange={onChange}
                  />
                </FormGroup>
                <FormGroup className="has-float-label">
                  <Label for="tax_code" className="text-muted">
                    Mã số thuế
                  </Label>
                  <Input
                    type="text"
                    name="tax_code"
                    id="tax_code"
                    placeholder="Ví dụ: 0101234567"
                    disabled={setting.viewonly && !setting.add}
                    value={values.tax_code || ""}
                    onChange={onChange}
                  />
                </FormGroup>
                <FormGroup className="has-float-label">
                  <Label for="notes" className="text-muted">
                    Ghi chú
                  </Label>
                  <Input
                    type="textarea"
                    rows="2"
                    name="notes"
                    id="notes"
                    placeholder="Ghi chú thông tin nhà cung cấp..."
                    disabled={setting.viewonly && !setting.add}
                    value={values.notes || ""}
                    onChange={onChange}



                  />
                </FormGroup>
                <FormGroup className="mt-3 has-float-label">
                  <Label for="item_name" className="text-muted">
                    <IntlMessages id="company-provider.item_name" />
                  </Label>
                  <Creatable
                    isMulti
                    placeholder={"Chọn hoặc tạo mới mặt hàng cung cấp"}
                    name="items_selected"
                    id="items_selected"
                    onChange={(val) => onChange(val, "items_selected")}
                    value={values.items_selected}
                    options={items_select}
                    formatCreateLabel={(inputValue) =>
                      `Tạo mới mặt hàng: "${inputValue}"`
                    }
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                  />
                </FormGroup>
                <DynamicForm
                  values={values.dynamic_form}
                  data={data_dynamic_form}
                  onChange={onChangeDynamicForm}
                  disabled={setting.viewonly && !setting.add}
                />
              </TabPane>

              {/* Tab 2: Add Transaction */}
              <TabPane tabId="2">
                <FormGroup className="mt-3 has-float-label">
                  <Label for="item_name" className="text-muted">
                    <IntlMessages id="company-provider.item_name" />
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Creatable
                    className={"react-select-creatable"}
                    placeholder={"Chọn hoặc tạo mới mặt hàng cung cấp"}
                    name="items_selected"
                    id="items_selected_transaction"
                    onChange={(val) => onChange(val, "items_selected")}
                    value={values.items_selected}
                    options={
                      provider_items_select.length > 0
                        ? provider_items_select
                        : items_select
                    }
                    formatCreateLabel={(inputValue) =>
                      `Tạo mới mặt hàng: "${inputValue}"`
                    }
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                  />
                </FormGroup>
                {values.items_selected?.__isNew__ && (
                  <FormGroup className="has-float-label">
                    <Label for="new_item_unit" className="text-muted">
                      Đơn vị tính <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      name="new_item_unit"
                      id="new_item_unit"
                      placeholder="Ví dụ: Cái, Bộ, Hộp"
                      value={values.new_item_unit || ""}
                      onChange={onChange}
                    />
                  </FormGroup>
                )}
                <Row>
                  <Colxx xxs="6">
                    <FormGroup className="has-float-label">
                      <Label for="price" className="text-muted">
                        <IntlMessages id="company-provider.price_new" />
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        type="text"
                        name="price"
                        id="price"
                        value={AddCommaNumber(values.price)}
                        onChange={onChange}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx xxs="6">
                    <FormGroup className="has-float-label">
                      <Label for="quantity" className="text-muted">
                        <IntlMessages id="company-provider.quantity" />
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        type="number"
                        name="quantity"
                        id="quantity"
                        value={values.quantity}
                        onChange={onChange}
                      />
                    </FormGroup>
                  </Colxx>
                </Row>
                <FormGroup className="has-float-label">
                  <Label for="price_outcome" className="text-muted">
                    <IntlMessages id="company-provider.total_price_outcome" />
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    name="price_outcome"
                    id="price_outcome"
                    placeholder="0"
                    value={AddCommaNumber(values.price_outcome)}
                    onChange={onChangePrice}
                  />
                </FormGroup>
                <FormGroup className="has-float-label">
                  <Label for="price_income" className="text-muted">
                    <IntlMessages id="company-provider.total_price_income" />
                  </Label>
                  <Input
                    disabled
                    name="price_income"
                    id="price_income"
                    placeholder="0"
                    value={AddCommaNumber(
                      Number(
                        (values.price || "0").toString().replace(/\./g, "") *
                          Number(values.quantity)
                      ) || 0
                    )}
                    onChange={onChangePrice}
                  />
                </FormGroup>
                <FormGroup className="has-float-label">
                  <Label for="price_pending" className="text-muted">
                    <IntlMessages id="company-provider.total_price_pending" />
                  </Label>
                  <Input
                    type="text"
                    name="price_pending"
                    id="price_pending"
                    placeholder="0"
                    disabled={true}
                    value={AddCommaNumber(values.price_pending)}
                  />
                </FormGroup>
              </TabPane>
            </TabContent>
          </PerfectScrollbar>
        </ModalBody>
        <ModalFooter>
          <Button color="primary">
            {activeTab === "1" ? (
              <IntlMessages id="general.btn-update" />
            ) : (
              <IntlMessages id="general.btn-add" />
            )}
          </Button>{" "}
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default React.memo(ContentComponent);
